import { Injectable } from '@angular/core'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { EnvironmentService } from 'app/environment.service'
import { ICreditCardWire, IPaymentResult, IConfirmResult, IFinalizeResult } from 'app/payment/payment.interfaces'
import { IReservation } from 'app/shared/models/reservation.interfaces'
import { AuthHttpService } from 'app/shared/auth-http.service'
import { ResourceService } from 'app/shared/resources/resource.service'
import { SalesChannelService } from 'app/shared/salesChannel/sales-channel.service'
import { toParamsObj } from 'app/shared/utils';

@Injectable()
export class PaymentService {

    private orchestationUrl
    private legacyWebApiUrl

    constructor(
        private http: HttpClient,
        private environmentService: EnvironmentService,
        private authHttp: AuthHttpService,
        private salesChannelService: SalesChannelService,
        private resourceService: ResourceService) {
        this.orchestationUrl = this.environmentService.getOrchestrationUrl()
        this.legacyWebApiUrl = this.environmentService.getSbServiceUrl()
    }

    getCreditCards(salesOwnerId: number, salesChannelCode: string): Observable<ICreditCardWire[]> {
        const url = `${this.legacyWebApiUrl}/api/payment/mechanisms/salesowner/${salesOwnerId}/channel/${salesChannelCode}`
        return this.http.get<ICreditCardWire[]>(url)
    }

    getReservation(reservationCode: string, token: string): Observable<IReservation> {
        const url = `${this.legacyWebApiUrl}/api/reservation/${reservationCode}`
        return this.http.get<IReservation>(url, { headers: this.getHeaders(token) })
    }

    postPayment(cardType: string, reservationCode: string, token: string): Observable<IPaymentResult> {
        const url = `/_mvc/booking/payment/outstanding/payment?reservationCode=${reservationCode}&cardType=${cardType}`
        const body = { reservationCode, cardType }
        return this.http.post<IPaymentResult>(url, body, { headers: this.getHeaders(token) })
    }

    getAgentFinalizeFlow(): Observable<IFinalizeResult> {
        let params = {
            'salesOwner': this.resourceService.getSalesOwner(),
            'salesChannel': this.salesChannelService.getCode()
        }

        const url = `${this.orchestationUrl}/agent/finalize`
        return this.authHttp.get<IFinalizeResult>(url, { params: toParamsObj(params) })
    }

    postAgentFinalizeFlow(reservationCode: string) {
        const url = `${this.orchestationUrl}/agent/confirm/${reservationCode}`
        const body = { reservationCode }
        return this.authHttp.post<IConfirmResult>(url, body)
    }

    private getHeaders(token: string): any {
        return {
            'Cache-Control': 'no-cache',
            'Authorization': `DFDSSB ${token}`
        }
    }

}
